export enum DashboardTabs {
  Active = 1,
  Archived,
  PreBuilt,
  MasterFile,
}
